// extracted by mini-css-extract-plugin
export default {"container":"errors_container__BSzn3","wrapper":"errors_wrapper__XK+Oh","code":"errors_code__fQ4RL","title":"errors_title__UBtA2","message":"errors_message__VYnxK"};